"use strict";
exports.__esModule = true;
var cheerio_1 = require("cheerio");
var getValue_1 = require("./getValue");
function parse(data, config) {
    var $;
    if (typeof data === 'string') {
        $ = cheerio_1.load(data);
    }
    else if (typeof data === 'function') {
        $ = data;
    }
    return getValue_1["default"]({ $: $ }, config);
}
exports["default"] = parse;
